<template>
    <div>
        <BookingConfirmation />
    </div>
</template>

<script>
import BookingConfirmation from "@/components/3pl/Operations/Dispatch/newdispatch/booking-confirmation.vue";
export default {
    components: {
        BookingConfirmation,
    },
}
</script>

<style lang="scss" scoped></style>